import { useState } from "react";
import { AppState, TxStatus } from "../../../types/types";

import BurnMintTab from "./BurnMintTab";
import StakingTab from "./StakingTab";
type TabsContainerProps = {
  appState: AppState;
  setAppState: React.Dispatch<React.SetStateAction<AppState>>;
  sliderRatio: number;
  setSliderRatio: React.Dispatch<React.SetStateAction<number>>;
  onTransactionSuccess: () => void;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setModalTx: React.Dispatch<
    React.SetStateAction<{
      txStatus: TxStatus;
      txHash: string | null;
    }>
  >;
  setBalanceRefresh: React.Dispatch<React.SetStateAction<number>>; // ✅ AJOUT
};

const TabsContainer: React.FC<TabsContainerProps> = ({
  appState,
  setAppState,
  sliderRatio,
  setSliderRatio,
  onTransactionSuccess,
  setShowModal,
  setBalanceRefresh,
  setModalTx,
}) => {
  const [activeTab, setActiveTab] = useState<"burnmint" | "staking">(
    "burnmint"
  );

  if (!appState.userAddress) return null;

  return (
    <section className="w-full px-4 sm:px-6 flex flex-col h-auto mt-6">
      {/* Tab buttons */}
      <div className="flex justify-center gap-2 flex-wrap mb-2">
        <button
          onClick={() => setActiveTab("burnmint")}
          className={`p-2 w-[120px] font-semibold transition text-sm ${
            activeTab === "burnmint"
              ? "bg-primary-dark text-white shadow"
              : "bg-white/30 hover:bg-white/40"
          }`}
        >
          Burn & Mint
        </button>
        <button
          onClick={() => setActiveTab("staking")}
          className={`p-2 w-[120px] font-semibold transition text-sm ${
            activeTab === "staking"
              ? "bg-secondary text-white shadow"
              : "bg-white/30 hover:bg-white/40"
          }`}
        >
          Staking
        </button>
      </div>

      {/* Tab Content */}
      <div className="flex flex-col flex-1 gap-2 bg-white/20 backdrop-blur-md border border-white/20 shadow p-3 sm:p-4 w-full max-w-full sm:max-w-[700px] h-full mx-auto text-xs my-6 py-6">
        <div className="flex-1 flex flex-col">
          {activeTab === "burnmint" ? (
            <BurnMintTab
              appState={appState}
              setAppState={setAppState}
              sliderRatio={sliderRatio}
              setSliderRatio={setSliderRatio}
              onTransactionSuccess={onTransactionSuccess}
              setShowModal={setShowModal}
              setModalTx={setModalTx}
            />
          ) : (
            <StakingTab setBalanceRefresh={setBalanceRefresh} />
          )}
        </div>
      </div>
    </section>
  );
};

export default TabsContainer;
